import { useActiveCompany } from "shared/hooks";
import { useVeroFlag } from "shared/utils/featureFlags";
import { VeroFlag } from "shared/utils/veroFlags";

export const useDealSummaryRedesign = (): boolean => {
  const flag = useVeroFlag(VeroFlag.useDealSummaryRedesignProduct1270);
  const { activeCompany } = useActiveCompany();
  return flag || Boolean((activeCompany as any)?.isVero1Client);
};
